/*** IMPORTS FROM imports-loader ***/
(function() {

define([
	'pip-model',
  'pip-events',
  'pip-common.utils',
	'window',
],
function(
	pip,
  pipEvents,
  pipCommonUtils,
	window
){
	function initEventListeners() {
    pipEvents.buyOneGetOne.buyOneGetOneAnalytics.off();
		pipEvents.buyOneGetOne.buyOneGetOneAnalytics.on(function(){
			var contentModule = {
        name: "buy box",
        feature: "bogo",
        type: "cta"
      };

			if (pipCommonUtils.deepGet(window, 'digitalData.content.module')){
				window.digitalData.content.module.push(contentModule);
			}
		});
	}

	return {
		init: function(){
			if (pip.features.buyOneGetOneFreeEnabled){
				initEventListeners();
			}
		}
	}
});

}.call(window));